/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import api from '../http/requests/api/index.js'


const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  checkTokenValid ({ commit }) {

    return new Promise((resolve, reject) => {
      api.checkToken()
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('SET_TOKEN_VALID', true)
            commit('UPDATE_USER_INFO', response.data)
            resolve(response)
          } else {
            commit('SET_TOKEN_VALID', false)
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getCamImages ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getCamImages(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_CAM_IMAGES', response.data.images)
            resolve(response)
          } else {
            reject(response)
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getConsecutiveImages ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getConsecutiveImages(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_CAM_IMAGES', response.data.images)
            resolve(response)
          } else {
            reject(response)
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setCameraPtz ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.setCameraPtz(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_PTZ', response.data.data.ptz)
            resolve(response)
          } else {
            reject(response)
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setCameraRotation ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.setCameraRotation(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_PTZ', response.data.data.ptz)
            resolve(response)
          } else {
            reject(response)
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getEventCamera ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getEventCamera(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_PTZ', response.data.data.ptz)
            commit('SET_CAMERA', response.data.data.camera)
            resolve(response)
          } else {
            reject(response)
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getEvents ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getEvents(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            commit('SET_EVENT_DATA', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getLogsLast ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getLogsLast(payload)
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getEventsAll ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getEventsAll()
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getBolgeEvents ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getBolgeEvents()
        .then(response => {
          // If there's user data in response
          if (response.status === 200) {
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getEventDetails ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getEventDetails(payload)
        .then(response => {
          console.log('event detail', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_EVENT_DETAIL', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getUser ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getUser()
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('UPDATE_USER_INFO', response.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getAnyUser ({ commit }) {

    return new Promise((resolve, reject) => {
      api.getUser()
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getUserList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getUserList(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            const user_list = response.data.data
            const items = response.data.items
            const count = response.data.count
            const limit = count - items
            if (limit > 0) {
              for (let i = 0; i < limit; i++) {
                //user_list.push({})
              }
            }

            commit('SET_USER_LIST', user_list)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },

  getUserValidation ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getUserValidation(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },

  addUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('addUser', payload)
      api.addUser(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  editUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('edit kule', payload)
      api.editUser(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  deleteUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deleteUser(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  deleteEvent ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.deleteEvent(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('', '')
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  editEvent ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.editEvent(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('UPDATE_EVENT_DATA', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  loginUser ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.loginUser(payload)
        .then(response => {

          console.log('respons', response)
          // If there's user data in response
          if (response.status === 200) {
            console.log('successful login')
            console.log(response.data)

            commit('', '')
            localStorage.accessToken = response.data.token
            resolve(response)
          } else {
            reject({message: response})
          }

        })
        .catch(error => { reject({message: error.response.data.status }) })
    })
  },

  getBolgeList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getBolgeList(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('UPDATE_BOLGE_DATA', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },

  addBolge ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('add bolge', payload)
      api.addBolge(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  editBolge ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('add bolge', payload)
      api.updateBolge(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },

  deleteBolge ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.deleteBolge(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },

  getIsletmeList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getIsletmeList(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_ISLETME_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addIsletme ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('add isletme', payload)
      api.addIsletme(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  editIsletme ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('edit Isletme', payload)
      api.updateIsletme(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  deleteIsletme ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.deleteIsletme(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },


  getSeflikList ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      api.getSeflikList(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_SEFLIK_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addSeflik ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('add seflik', payload)
      api.addSeflik(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  editSeflik ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('edit seflik', payload)
      api.updateSeflik(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  deleteSeflik ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.deleteSeflik(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getKameraList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getKameraList(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_KAMERA_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getKameraListAll ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getKameraListAll(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_KAMERA_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getKuleAnalyze ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getKuleAnalyze()
        .then(response => {
          if (response.status === 200) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getStatusList ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getStatusList()
        .then(response => {
          if (response.status === 200) {
            resolve(response)
            commit('PASS', true)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  getKuleList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.getKuleList(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data.data)
            commit('SET_KULE_LIST', response.data.data)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addKule ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('add kule', payload)
      api.addKule(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  editKule ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('edit kule', payload)
      api.editKule(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  deleteKule ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.deleteKule(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },

  addKamera ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('add Kamera', payload)
      api.addKamera(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  addKameraCSV ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('add Kamera csv', payload)
      api.addKameraCSV(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  editKamera ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log('edit Kamera', payload)
      api.editKamera(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  },
  deleteKamera ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.deleteKamera(payload)
        .then(response => {
          console.log(response)
          // If there's user data in response
          if (response.status === 200) {
            console.log(response.data)
            commit('PASS', true)
            resolve(response)
          } else {
            reject({message: 'error'})
          }

        })
        .catch(error => { reject(error) })
    })
  }
}

export default actions
